/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import DoneIcon from '@mui/icons-material/Done';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { StatCardV2 } from '../../../components/v2';
import TableService from '../../../services/TableService';

const STATUS_CONFIG = [
  {
    key: 'AGUARDANDO_VALIDACAO',
    label: 'Aguardando Validação',
    color: 'info',
    icon: <InfoIcon />,
  },
  {
    key: 'VALIDADO',
    label: 'Validado',
    color: 'success',
    icon: <DoneIcon />,
  },
  {
    key: 'INVALIDADO',
    label: 'Invalidado',
    color: 'error',
    icon: <ReportProblemIcon />,
  },
];

const EMPTY_COUNTS = {
  filtrado: {},
  total: {},
};

/** Normaliza resposta plana (legado) ou `{ filtrado, total }`. */
const normalizeResumo = (data) => {
  if (!data || typeof data !== 'object') {
    return EMPTY_COUNTS;
  }
  if (data.filtrado != null || data.total != null) {
    return {
      filtrado: data.filtrado && typeof data.filtrado === 'object' ? data.filtrado : {},
      total: data.total && typeof data.total === 'object' ? data.total : {},
    };
  }
  return { filtrado: data, total: {} };
};

const formatCardValue = (filtrado, total) => {
  const filteredCount = filtrado ?? null;
  const totalCount = total ?? null;

  if (filteredCount == null && totalCount == null) {
    return { valueFiltered: null, valueTotal: null };
  }

  return {
    valueFiltered: filteredCount ?? 0,
    valueTotal: totalCount ?? null,
  };
};

/** Recebe o mesmo objeto de filtro enviado a `notas/filter`, mas **sem** campo `validate`. */
const NotasResumoCards = ({ apiFilterBase, activeStatus, onFilterByStatus, refreshKey }) => {
  const [counts, setCounts] = useState(EMPTY_COUNTS);
  const [loading, setLoading] = useState(false);

  const fetchCounts = useCallback(async () => {
    setLoading(true);

    try {
      const response = await TableService.request('notas/resumo', apiFilterBase);
      setCounts(normalizeResumo(response?.data));
    } catch {
      setCounts(EMPTY_COUNTS);
    } finally {
      setLoading(false);
    }
  }, [apiFilterBase, refreshKey]);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  return (
    <Grid container spacing={2}>
      {STATUS_CONFIG.map((config) => {
        const cardValues = formatCardValue(
          counts.filtrado[config.key],
          counts.total[config.key],
        );
        return (
        <Grid key={config.key} size={{ xs: 6, sm: 4 }}>
          <StatCardV2
            label={config.label}
            valueFiltered={cardValues.valueFiltered}
            valueTotal={cardValues.valueTotal}
            totalCaption="no total"
            icon={config.icon}
            color={config.color}
            loading={loading}
            active={activeStatus === config.key}
            onClick={() =>
              onFilterByStatus(activeStatus === config.key ? null : config.key)
            }
          />
        </Grid>
        );
      })}
    </Grid>
  );
};

NotasResumoCards.propTypes = {
  apiFilterBase: PropTypes.object.isRequired,
  activeStatus: PropTypes.string,
  onFilterByStatus: PropTypes.func.isRequired,
  refreshKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
};

NotasResumoCards.defaultProps = {
  activeStatus: null,
  refreshKey: false,
};

export default NotasResumoCards;
